import { list } from "postcss";

export const translations = {
	thorSeries: {
		h1_title: {
			en: "THOR SERIES",
			fr: "SÉRIE THOR",
		},
		h2_choose_your_model: {
			en: "Choose your model",
			fr: "Choisissez votre modèle",
		},
		thor_list: {
			en: [
				"4-wheel disc brakes",
				"Bluetooth touch screen",
				"Led lights",
				"Seatbelts",
				"48V 110Ah lithium battery",
				"Electric parking brake",
				"Rear view camera",
				"14 inch wheel",
				"Integrated charger",
				"Trunk",
				"Controller Curtis 400A",
				"Turn signal, stop light, fog light",
				"6.3 kW Motor with EM brake",
				"Front bumper",
				"Cargo Box"
			],
			fr: [
				"Freins à disque 4 roues",
				"Écran tactile Bluetooth",
				"Lumières LED",
				"Ceintures de sécurité",
				"Batterie lithium 48V 110Ah",
				"Frein de stationnement électrique",
				"Caméra de recul",
				"Roue de 14 pouces",
				"Chargeur intégré",
				"Coffre arrière",
				"Contrôleur Curtis 400A",
				"Clignotant, feu d'arrêt, lumière antibrouillard",
				"Moteur 6.3 kW avec frein EM",
				"Pare-chocs avant",
				"Boîte de chargement"
			],
		},
		h3_colorPicker: {
			en: "Color Options",
			fr: "Options de couleur",
		},
		p_colorPicker: {
			en: "*Please note that due to variations between screens, actual colors may vary. Check with your dealer for actual colors.",
			fr: "*Veuillez noter qu'en raison des variations entre les écrans, les couleurs réelles peuvent varier. Vérifiez auprès de votre revendeur les couleurs réelles.",
		},
		p_touch_screen_compatible: {
			en: "Touchscreen compatible with Apple Carplay & Android Auto",
			fr: "Écran tactile compatible avec Apple Carplay & Android Auto",
		},
		p_touch_screen_aftermarks: {		
			en: "Apple CarPlay and Android Auto are aftermarket features, not included as part of the golf car's factory-installed products. Dealers may specify or offer these features separately. Additional fees may apply. Please check with your local dealer for details",
			fr: "Apple CarPlay et Android Auto sont des fonctionnalités après-vente, non incluses dans les produits installés en usine de la voiturette de golf. Les concessionnaires peuvent spécifier ou offrir ces fonctionnalités séparément. Des frais supplémentaires peuvent s'appliquer. Veuillez vérifier auprès de votre revendeur local pour plus de détails",
		},
		h2_span_discover: {
			en: "EXPLORE THOR SERIES",
			fr: "EXPLOREZ LA SÉRIE THOR",
		},
		h2_discover: {
			en: "Discover the comfort and innovation",
			fr: "Découvrez le confort et l'innovation",
		},
		h2_discoverNext: {
			en: "of our carts.",
			fr: "de nos voiturettes.",
		},
		p_discover: {
			en: "The Thor Series offers a range of high-performance electric vehicles designed for both urban and off-road adventures. With cutting-edge technology and sleek designs, the Luxor Series is perfect for those who seek both style and functionality.",
			fr: "La série Thor propose une gamme de véhicules électriques de haute performance conçus pour les aventures urbaines et tout-terrain. Avec une technologie de pointe et des designs élégants, la série Thor est parfaite pour ceux qui recherchent à la fois style et fonctionnalité.",
		},
		t_features_screen: {
			en: "9” MULTI-FUNCTIONAL TOUCHSCREEN",
			fr: "ÉCRAN TACTILE MULTIFONCTIONNEL 9”"
		},
		p_features_screen: {
			en: "Elevate your off-road adventures with our 9” touchscreen.",
			fr: "Rehaussez vos aventures tout-terrain avec notre écran tactile 9”."
		},
		t_features_tires: {
			en: "TIRES",	
			fr: "PNEUS",
		},
		p_features_tires: {
			en: "Experience the ultimate off-road adventure with our high-performance tires, designed to conquer the toughest terrain. These rugged tires feature advanced tread patterns, providing unmatched grip and stability on uneven surfaces. Whether you're taking part in an exhilarating expedition or taking on off-road challenges, our tires provide a smooth, quiet ride while providing exceptional durability.",
			fr: "Vivez l'aventure tout-terrain ultime avec nos pneus haute performance, conçus pour conquérir les terrains les plus difficiles. Ces pneus robustes présentent des motifs de bande de roulement avancés, offrant une adhérence et une stabilité inégalées sur des surfaces inégales. Que vous participiez à une expédition exaltante ou que vous releviez des défis tout-terrain, nos pneus offrent une conduite douce et silencieuse tout en offrant une durabilité exceptionnelle."	
		},
		t_features_wheels: {
			en: "HIGH QUALITY ALIMINUM WHEEL",
			fr: "ROUE EN ALUMINIUM DE HAUTE QUALITÉ",
		},

		p_features_wheels: {
			en: "Our high-quality aluminum wheels are designed to provide the ultimate in performance and durability. These lightweight wheels are engineered to deliver superior handling and stability, ensuring a smooth and comfortable ride. Whether you're navigating city streets or tackling off-road trails, our aluminum wheels will help you conquer any terrain with ease.",
			fr: "Nos roues en aluminium de haute qualité sont conçues pour offrir le summum en matière de performance et de durabilité. Ces roues légères sont conçues pour offrir une maniabilité et une stabilité supérieures, garantissant une conduite douce et confortable. Que vous naviguiez dans les rues de la ville ou que vous affrontiez des sentiers tout-terrain, nos roues en aluminium vous aideront à conquérir n'importe quel terrain avec facilité."
		},
		t_features_cargoBox: {	
			en: "CARGO BOX",
			fr: "BOÎTE DE CHARGEMENT",
		},
		p_features_cargoBox: {
			en: "Handle heavy loads? Our sturdy aluminum tilting cargo box with rear air shocks provides plenty of space for tools, bags or any other essential items you need to move. Ideal for a variety of tasks from farming to quick beach getaways, its ultra-strong construction promises longevity and resilience.",
			fr: "Manipulez des charges lourdes? Notre robuste boîte de chargement basculante en aluminium avec amortisseurs pneumatiques arrière offre beaucoup d'espace pour les outils, les sacs ou tout autre article essentiel que vous devez déplacer. Idéale pour une variété de tâches, de l'agriculture aux escapades rapides à la plage, sa construction ultra-résistante promet longévité et résilience."
		},
		t_features_hitch: {
			en: "HITCH",
			fr: "ATTELAGE"
		},
		p_features_hitch: {
			en: "Our tow hitch isn't just about strength it's also about smooth, efficient towing. Designed to eliminate the need for external towing services, it ensures you can complete towing tasks quickly, saving time and money.",
			fr: "Notre attelage n'est pas seulement une question de force il s'agit aussi de remorquer en douceur et efficacement. Conçu pour éliminer le besoin de services de remorquage externes, il vous permet d'effectuer rapidement des tâches de remorquage, vous faisant gagner du temps et de l'argent."
		},
		t_features_bumper: {
			en: "FRONT BUMPER",
			fr: "PARE-CHOCS AVANT"
		},
		p_features_bumper: {
			en: "The front bumper of the Thor vehicle is much more than just an aesthetic element. It is an essential safety device designed to protect your vehicle from minor impacts and minimize potential damage in the event of an accident.",
			fr: "Le pare-chocs avant du véhicule Thor est bien plus qu'un simple élément esthétique. C'est un dispositif de sécurité essentiel conçu pour protéger votre véhicule contre les impacts mineurs et minimiser les dommages potentiels en cas d'accident."
		},
		h2_spec_title: {
			en: "SPECIFICATIONS",
			fr: "SPÉCIFICATIONS",
		},
		h3_spec_dimensions: {
			en: "DIMENSIONS",
			fr: "DIMENSIONS",
		},
		h3_spec_cargoBox: {
			en: "CARGO BOX DIMENSIONS",
			fr: "DIMENSIONS DE LA BOÎTE DE CHARGEMENT",
		},
		h3_spec_power: {
			en: "POWER",
			fr: "PUISSANCE",
		},
		h3_spec_features: {
			en: "FEATURES",
			fr: "FONCTIONNALITÉS",
		},
		list_spec_power: {
			en: [
				"48 V 110 Ah Lithium battery",
				"6.3 kW motor with EM brake",
				"400 A, AC controller",
				"Integrated 25 A charger",
				"Maximum speed ≥ 40 km/h (25 mph)"
			],
			fr: [
				"Batterie lithium 48 V 110 Ah",
				"Moteur 6.3 kW avec frein EM",
				"Contrôleur 400 A, AC",
				"Chargeur intégré 25 A",
				"Vitesse maximale ≥ 40 km/h (25 mph)"
			],
		},
		list_spec_features: {
			en: [
				"Double wishbone suspension for a smooth, quality ride feel",
				"Decorative strip",
				"Colorful decorative hubcaps",
				"Dashboard with color-matched cup holder insert",
				"Luxury steering wheel",
				"Rearview mirror",
				"EM brake",
				"LED lighting",
				"Turn signal, stop light",
				"USB charging ports",
				"Aluminum cargo box (Tilting, with pneumatic shock absorbers)",
				"14×7” Aluminum Wheel/ 23×10-14 Silent Tire with Off-road Thread",
				"Transparent folding windshield",
				"9” Multi-functional Touchscreen (Apple Carplay & Android Auto Compatibility, Speed display, Driving Gear indication, Lights, Odometer, Radio, Music, Bluetooth Connection, Back-up camera, etc.)",
			],
			fr: [
				"Suspension à double triangulation pour une conduite douce et de qualité",
				"Bande décorative",
				"Enjoliveurs décoratifs colorés",
				"Tableau de bord avec insert de porte-gobelet assorti à la couleur",
				"Volant de luxe",
				"Rétroviseur",
				"Frein EM",
				"Éclairage LED",
				"Clignotant, feu d'arrêt",
				"Ports de charge USB",
				"Boîte de chargement en aluminium (basculante, avec amortisseurs pneumatiques)",
				"Roue en aluminium 14×7”/ Pneu silencieux 23×10-14 avec filetage tout-terrain",
				"Pare-brise pliant transparent",
				"Écran tactile multifonctionnel 9” (compatibilité Apple Carplay & Android Auto, affichage de la vitesse, indication du rapport de conduite, lumières, compteur kilométrique, radio, musique, connexion Bluetooth, caméra de recul, etc.)",
			],
		},
		h2_shrink_charger: {
			en: "CHARGING PLUG",	
			fr: "PRISE DE CHARGE",
		},
		p_shrink_charger: {
			en: "Charge your battery with this integrated charger.",
			fr: "Chargez votre batterie avec ce chargeur intégré.",
		},
		h2_shrink_cupHolders: {
			en: "CUP HOLDERS",
			fr: "PORTE-GOBELETS",
		},
		p_shrink_cupHolders: {
			en: "Keep your drinks secure with these cup holders.",
			fr: "Gardez vos boissons en sécurité avec ces porte-gobelets.",
		},
		h2_shrink_dashStorage: {
			en: "DASHBOARD",
			fr: "TABLEAU DE BORD",
		},
		p_shrink_dashStorage: {
			en: "Store your items conveniently on the dashboard.",
			fr: "Rangez vos articles commodément sur le tableau de bord.",
		},
		h2_shrink_storage: {
			en: "STORAGE",
			fr: "RANGEMENT",
		},
		p_shrink_storage: {
			en: "Ample storage space for all your needs.",
			fr: "Un espace de rangement ample pour tous vos besoins.",
		},
		h2_shrink_usbPorts: {
			en: "USB PORTS",
			fr: "PORTS USB",
		},
		p_shrink_usbPorts: {
			en: "Charge your devices with multiple USB ports.",
			fr: "Chargez vos appareils avec plusieurs ports USB.",
		},
		h2_shrink_golfCompartment: {
			en: "GOLF BALL HOLDER",
			fr: "PORTE-BALLES DE GOLF",
		},	
		p_shrink_golfCompartment: {
			en: "Keep you ready for golfing, Holes for four golf balls",
			fr: "Gardez-vous prêt pour le golf, trous pour quatre balles de golf",
		},
		h2_shrink_mirrorFlashers: {
			en: "POWERED REAR VIEW MIRRORS",
			fr: "MIROIRS DE VUE ARRIÈRE ÉLECTRIQUES",
		},
		p_shrink_mirrorFlashers: {
			en: "Powered Rear View mirrors with turn signal indicator lights",
			fr: "Miroirs de vue arrière électriques avec clignotants",
		},
		h2_shrink_storageCompartment: {
			en: "STORAGE COMPARTMENT",
			fr: "COMPARTIMENT DE RANGEMENT",
		},
		p_shrink_storageCompartment: {
			en: "Extra easy-access storage compartment in the dashboard",
			fr: "Compartiment de rangement supplémentaire facile d'accès sur le tableau de bord",
		},
		h2_shrink_soundBar: {
			en: "SOUND BAR",
			fr: "BARRE DE SON",
		},
		p_shrink_soundBar: {
			en: "Wirelessly connect to the screen with adjustable lighting modes and LED lights",
			fr: "Connectez-vous sans fil à l'écran avec des modes d'éclairage réglables et des lumières LED",
		},
		h2_shrink_handles: {
			en: "CEILING HANDLE",
			fr: "POIGNÉE DE PLAFOND",
		},
		p_shrink_handles: {
			en: "Provides ergonomic support for your cantilevered elbows",
			fr: "Fournit un support ergonomique pour vos coudes en porte-à-faux",
		},
	},
} as const;

type TranslationKeys = typeof translations.thorSeries.h1_title;
export type Language = keyof TranslationKeys;
